import React from 'react';
import propTypes from 'prop-types';

const ActionProvider = ({ createChatBotMessage, setState, children }) => {
    const handleEmailOption = (userInput) => {
        const widget = 'emailGPT';

        const botMessage = createChatBotMessage(
            'Okay I can help you create a custom email! Give me some background info on what the email should be about!'
        );

        addMessageToState(botMessage, userInput, widget);
    };

    const handleEmailGeneration = (userInput) => {
        const botMessage = createChatBotMessage('Okay no problem! let me think of something...', {
            widget: 'emailGPT',
        });
        addMessageToState(botMessage, userInput);
    };

    const handleHelpOption = () => {
        const botMessage = createChatBotMessage('Click to expand and learn more!', {
            widget: 'helpDrawer',
        });
        addMessageToState(botMessage);
    };

    const handleVideoOption = () => {
        const botMessage = createChatBotMessage('Here is a quick video of how davie.ai works!', {
            widget: 'videoPlayer',
        });
        addMessageToState(botMessage);
    };
    const handleSupportOption = () => {
        const botMessage = createChatBotMessage('Ask me any question about davie.ai!', {});
        addMessageToState(botMessage);
    };

    const handleSupportGeneration = (userInput) => {
        const botMessage = createChatBotMessage("Hold on I'm thinking...", {
            widget: 'supportGPT',
        });
        addMessageToState(botMessage, userInput);
    };

    const handleDefaultResponse = () => {
        const botMessage = createChatBotMessage('What would you like help with?', {
            widget: 'options',
        });
        addMessageToState(botMessage);
    };
    const handleYes = () => {
        const botMessage = createChatBotMessage('What would you like help with?', {
            widget: 'options',
        });
        addMessageToState(botMessage);
    };
    const handleNo = () => {
        const botMessage = createChatBotMessage("Okay, if You need anything i'll be here. Just ask a question or select an option below.", {
            widget: 'options',
        });
        addMessageToState(botMessage);
    };

    const addMessageToState = (message, userInput, widget) => {
        setState((prev) => ({
            ...prev,
            messages: [...prev.messages, message],
            userInput,
            widget,
        }));
    };

    return (
        <div>
            {React.Children.map(children, (child) => {
                return React.cloneElement(child, {
                    actions: {
                        handleEmailGeneration,
                        handleEmailOption,
                        handleVideoOption,
                        handleHelpOption,
                        handleSupportOption,
                        handleSupportGeneration,
                        handleDefaultResponse,
                        handleYes,
                        handleNo,
                    },
                });
            })}
        </div>
    );
};

ActionProvider.propTypes = {
    createChatBotMessage: propTypes.func,
    setState: propTypes.func,
    children: propTypes.node,
};

export default ActionProvider;
